<template>
  <section style="height:100%">
    <el-row>
      <el-col :span="4" style="height:100%" v-bind:style="{height: menuHeight}">
        <el-menu :default-active="activedIndex" :default-openeds="['1-1','1-2', '1-3', '1-4']" style="height:100%;border-radius: 0 !important" theme="dark"
                 :router="true">
          <el-submenu index="1-1">
            <template slot="title">日运行曲线</template>
            <el-menu-item index="/energy/active-power">有功功率曲线</el-menu-item>
            <el-menu-item index="/energy/inactive-power">无功功率曲线</el-menu-item>
            <el-menu-item index="/energy/current">电流曲线</el-menu-item>
            <el-menu-item index="/energy/voltage">电压曲线</el-menu-item>
            <el-menu-item index="/energy/power-factor">功率因素曲线</el-menu-item>
            <!--<el-menu-item index="/energy/harmonic">谐波曲线</el-menu-item>-->
          </el-submenu>
          <el-submenu index="1-2">
            <template slot="title">电量监测</template>
            <el-menu-item index="/energy/consume">电量数据</el-menu-item>
          </el-submenu>
          <el-submenu index="1-3">
            <template slot="title">电力基础数据</template>
            <!--<el-menu-item index="/energy/load">单负荷对比</el-menu-item>-->
            <el-menu-item index="/energy/load">负荷率数据</el-menu-item>
          </el-submenu>
          <!--<el-submenu index="1-4">-->
            <!--<template slot="title">能耗对比</template>-->
            <!--<el-menu-item index="/energy/single">单负荷对比</el-menu-item>-->
            <!--<el-menu-item index="/energy/mutil">多对象负荷</el-menu-item>-->
          <!--</el-submenu>-->
        </el-menu>
      </el-col>
      <el-col :span="20" style="height:100%;padding:20px;">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-col>
    </el-row>
  </section>

</template>
<style>
</style>
<script>
  export default{
    data() {
      return {
        me: JSON.parse(sessionStorage.getItem('user')),
        activedIndex: '/energy/active-power',
        menuHeight: (window.innerHeight - 60) + 'px',
      }
    },
    mounted() {
      this.activedIndex =  this.$route.path;
    }
  }
</script>



// WEBPACK FOOTER //
// EnergyLayout.vue?0317ef3a